import { useQuery } from "react-query";
import { transportationService } from "../../services/transportationService";
import { accountScopedQueryOptions, useAccountQueryContext } from "../useAccountQueryContext";

export const useTransportRoutes = (filters, options = {}) => {
  const { tokenValue, accountKey } = useAccountQueryContext();
  return useQuery(
    ["transportation", "routes", accountKey, filters],
    () => transportationService.getRoutes(tokenValue, filters),
    { ...accountScopedQueryOptions, keepPreviousData: true, enabled: Boolean(tokenValue) && options.enabled !== false, ...options }
  );
};
